import {
  OrderExecutionTermsOperationKind,
  OrderExecutionTermsOrderType,
} from 'api/types/entity/order/orderExecutionTermsEntity';
import { lodash } from 'helpers';
import { useTranslation } from 'libs/i18n';
import { OrderSection } from 'modules/order/common/components';
import { MAX_FLOATING_POINTS } from 'modules/order/common/constants';
import { Field } from 'modules/order/common/forms/orderForm';

interface Props {
  isShowOrderType: boolean;
  isShowOperationKind: boolean;
  isShowYield: boolean;
  isShowOperationPurpose?: boolean;
  isShowAdditionalNotes?: boolean;
}

export const ExecutionTermsSection = ({
  isShowOperationKind,
  isShowOrderType,
  isShowYield,
  isShowOperationPurpose,
  isShowAdditionalNotes,
}: Props) => {
  const { t } = useTranslation();
  return (
    <OrderSection
      fields={lodash.compact([
        isShowOrderType && (
          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'order.sections.executionTermsSection.fields.orderType.label'
            )}
            name="executionTerms.orderType"
            optionLabelKey="label"
            options={Object.values(OrderExecutionTermsOrderType).map(
              (type) => ({
                label: t(`order.executionTermsOrderType.${type}`),
                value: type,
              })
            )}
            optionValueKey="value"
            placeholder={t(
              'order.sections.executionTermsSection.fields.orderType.placeholder'
            )}
            variant="select"
          />
        ),
        isShowOperationKind && (
          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'order.sections.executionTermsSection.fields.operationKind.label'
            )}
            name="executionTerms.operationKind"
            optionLabelKey="label"
            options={Object.values(OrderExecutionTermsOperationKind).map(
              (type) => ({
                label: t(
                  `order.sections.executionTermsSection.fields.operationKind.types.${type}`
                ),
                value: type,
              })
            )}
            optionValueKey="value"
            placeholder={t(
              'order.sections.executionTermsSection.fields.operationKind.placeholder'
            )}
            variant="select"
          />
        ),
        isShowYield && (
          <Field.Decimal
            fullWidth
            label={t('order.sections.executionTermsSection.fields.yield.label')}
            maxFloatingPoints={MAX_FLOATING_POINTS}
            name="executionTerms.yield"
            placeholder={t(
              'order.sections.executionTermsSection.fields.yield.placeholder'
            )}
          />
        ),
        isShowOperationPurpose && (
          <Field.Text
            fullWidth
            label={t(
              'order.sections.executionTermsSection.fields.operationPurpose.label'
            )}
            name="executionTerms.operationPurpose"
            placeholder={t(
              'order.sections.executionTermsSection.fields.operationPurpose.placeholder'
            )}
          />
        ),
        isShowAdditionalNotes && (
          <Field.Text
            fullWidth
            label={t(
              'order.sections.additionalNotesSection.fields.additionalNotes.label'
            )}
            name="executionTerms.additionalNotes"
            placeholder={t(
              'order.sections.additionalNotesSection.fields.additionalNotes.placeholder'
            )}
          />
        ),
      ])}
      title={t('order.sections.executionTermsSection.title')}
    />
  );
};
